import $ from 'jquery';

$(function() {
	// Default Sub-content behaviors
	$('.form-subcontent').each(function(i){
		var targetName = $(this).data('target-name');
		var targetValue = $(this).data('target-value');
		$('[name=' + targetName + '][value=' + targetValue + ']').on('change', function(){
			updateSubcontent(targetName, targetValue);
		});
	});


	// Setup any collapsible tables
	$('#main-page-wrapper').on('click', '.collapsible-table-toggle', function(e){
		e.preventDefault();
		$(this).parent().toggleClass('open');
		return false;
	});

	// Set up any delete buttons on the page
	window.deleteSetup();
	multiFormDeleteSetup();

	window.iziToast.settings({ position: 'topRight' });
});

function updateSubcontent(targetName, targetValue){
	var inputType = $('input[name=' + targetName + '][value=' + targetValue + ']').attr('type');
	if (inputType === 'radio'){
		$('.form-subcontent.active[data-target-name=' + targetName + ']').removeClass('active');
		$('.form-subcontent[data-target-name=' + targetName + '][data-target-value=' + targetValue + ']').addClass('active');
	}
	else if (inputType === 'checkbox'){
		$('.form-subcontent[data-target-name=' + targetName + '][data-target-value=' + targetValue + ']').toggleClass('active');
	}
}
